import { AnimatePresence, MotionConfig } from "motion/react";
import { Toaster } from "react-hot-toast";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { CartDrawer } from "./components/cart/CartDrawer";
import { CheckoutModal } from "./components/cart/CheckoutModal";
import { Navbar } from "./components/layout/Navbar";
import { PageTransition } from "./components/layout/PageTransition";
import { ActiveSectionProvider } from "./context/ActiveSectionContext";
import { CartProvider } from "./context/CartContext";
import { CustomizerProvider } from "./context/CustomizerContext";
import { SmoothScrollProvider, useSmoothScroll } from "./context/SmoothScrollContext";
import Cardapio from "./pages/Cardapio";
import Home from "./pages/Home";
import MonteSeuLanche from "./pages/MonteSeuLanche";
import Sucesso from "./pages/Sucesso";

const AnimatedRoutes = () => {
  const location = useLocation();
  const { scrollTo } = useSmoothScroll();

  return (
    // Espera a página atual sair, sobe para o topo e só então mostra a próxima.
    <AnimatePresence mode="wait" onExitComplete={() => scrollTo(0, { immediate: true })}>
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<PageTransition><Home /></PageTransition>} />
        <Route path="/cardapio" element={<PageTransition><Cardapio /></PageTransition>} />
        <Route path="/monte-seu-lanche" element={<PageTransition><MonteSeuLanche /></PageTransition>} />
        <Route path="/sucesso" element={<PageTransition><Sucesso /></PageTransition>} />
      </Routes>
    </AnimatePresence>
  );
};

function App() {
  return (
    // reducedMotion="user": com prefers-reduced-motion o Motion desliga animações de transform/layout.
    <MotionConfig reducedMotion="user">
      <BrowserRouter>
        <SmoothScrollProvider>
          <CartProvider>
            <CustomizerProvider>
              <ActiveSectionProvider>
                <a
                  href="#conteudo"
                  className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[100] focus:rounded-full focus:bg-primary focus:px-5 focus:py-3 focus:font-semibold focus:text-night"
                >
                  Pular para o conteúdo
                </a>
                <Toaster
                  position="top-center"
                  reverseOrder={false}
                  toastOptions={{
                    style: {
                      background: "#1A1A1A",
                      color: "#FFFFFF",
                      border: "1px solid #2A2A2A",
                      borderRadius: "14px",
                      fontFamily: "Poppins, sans-serif",
                      fontSize: "14px",
                    },
                    success: { iconTheme: { primary: "#FFC107", secondary: "#0A0A0A" } },
                  }}
                />
                <Navbar />
                <AnimatedRoutes />
                <CartDrawer />
                <CheckoutModal />
              </ActiveSectionProvider>
            </CustomizerProvider>
          </CartProvider>
        </SmoothScrollProvider>
      </BrowserRouter>
    </MotionConfig>
  );
}

export default App;
